export const getDateForInputFieldFromTimestamp = (timestamp) => {
  if (!timestamp) return null
  return addTimezoneOffsetToTimestamp(timestamp).toLocaleDateString('sv')
}

export const addTimezoneOffsetToTimestamp = (timestamp) =>
  new Date(
    new Date(timestamp).getTime() + new Date().getTimezoneOffset() * 60 * 1000
  )

export const subtractTimezoneOffsetFromTimestamp = (timestamp) =>
  new Date(
    new Date(timestamp).getTime() - new Date().getTimezoneOffset() * 60 * 1000
  )
